export default function Review() {
  return (
    <div>
      <h2>Reviews</h2>
    </div>
  );
}